import Adobe from "./providers/adobe";
import Facebook from "./providers/facebook";
import GoogleAdwords from "./providers/google";
import * as MUTATIONS from "../config/constants/mutation-types";
import TikTok from "./providers/tiktok";
import PixelesMotor from "./brands/ofertaDigital";

const pixelDb = {
  triggers: {
    [MUTATIONS.ON_ROUTE]: {
      paso1: [
        "Adobe.paso1",
        "Facebook.paso1",
        "GoogleAdwords.paso1",
        "TikTok.paso1"
      ],
      paso2: [
        "Adobe.paso2",
        "Facebook.paso2",
        "GoogleAdwords.paso2",
        "TikTok.paso2"
      ],
      paso3: [
        "Adobe.paso3",
        "Facebook.paso3",
        "GoogleAdwords.paso3",
        "TikTok.paso3",
        "PixelesMotor.paso3"
      ],
      paso4: ["Adobe.paso4"],
      mensaje: ["Adobe.mensaje"]
    },
    [MUTATIONS.ADOBE_INTERNAL_LINK]: ["Adobe.internalLink"],
    [MUTATIONS.ADOBE_APP_STARTED]: ["Adobe.appStartedClick"]
  },
  providers: {
    Adobe,
    Facebook,
    GoogleAdwords,
    TikTok,
    PixelesMotor
  }
};

export default pixelDb;
